<perfect-scrollbar class="right-side-nav" [ngClass]="{'open': isRightSideNavOpen}" *ngIf="isRightSideNavOpen">
  <ul class="ant-menu ant-menu-root ant-menu-inline right-side-nav-menu" [class.ant-menu-rtl]="rtl"
      [ngClass]="{
          'ant-menu-dark' : isSideNavDark
      }">
 
    <ul class="ant-menu-items">
      <li [ngClass]="item.submenu?.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'"
          *ngFor="let item of filteredMenuItems; let i = index" 
          [class.ant-menu-submenu-open]="openSubmenus['top-' + i]"
          [routerLinkActive]="item.submenu?.length > 0 ? '' : 'ant-menu-item-selected'" 
          [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" class="ant-menu-submenu-title" 
           *ngIf="item.submenu?.length > 0" (click)="toggleSubmenu('top-' + i)">
          <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
          <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i>
          <span>{{ item.title | translate }}</span>
          <i class="ant-menu-submenu-arrow"></i>
        </a>
        <a *ngIf="!item.submenu?.length" class="ant-menu-submenu-title" 
           (click)="navigate(item)">
          <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
          <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i>
          <span>{{ item.title | translate }}</span>
        </a>

        <!-- Second Level -->
        <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" 
            *ngIf="item.submenu?.length > 0 && openSubmenus['top-' + i]">
          <li [ngClass]="subItem.submenu?.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'" 
              *ngFor="let subItem of item.submenu; let j = index" 
              [class.ant-menu-submenu-open]="openSubmenus['top-' + i + '-sub-' + j]"
              [routerLinkActive]="subItem.submenu?.length > 0 ? '' : 'ant-menu-item-selected'"
              [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-30" 
               *ngIf="subItem.submenu?.length > 0" (click)="toggleSubmenu('top-' + i + '-sub-' + j)">
              <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
              <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
              <span>{{ subItem.title | translate }}</span>
              <i class="ant-menu-submenu-arrow"></i>
            </a>
            <a *ngIf="!subItem.submenu?.length" class="ant-menu-submenu-title p-l-30" 
               (click)="navigate(subItem)">
              <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon" [theme]="subItem.iconTheme"></i>
              <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i>
              <span>{{ subItem.title | translate }}</span>
            </a>

            <!-- Third Level -->
            <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" 
                *ngIf="subItem.submenu?.length > 0 && openSubmenus['top-' + i + '-sub-' + j]">
              <li [ngClass]="subSubItem.submenu?.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline' : 'ant-menu-item'" 
                  *ngFor="let subSubItem of subItem.submenu; let k = index" 
                  routerLinkActive="ant-menu-item-selected" 
                  [routerLinkActiveOptions]="{exact: true}">
                <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50" 
                   *ngIf="subSubItem.submenu?.length > 0" (click)="toggleSubmenu('top-' + i + '-sub-' + j + '-sub-' + k)">
                  <i *ngIf="subSubItem.iconType == 'nzIcon'" nz-icon [nzType]="subSubItem.icon" [theme]="subSubItem.iconTheme"></i>
                  <i *ngIf="subSubItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subSubItem.iconTheme, subSubItem.icon]"></i>
                  <span>{{ subSubItem.title | translate }}</span>
                  <i class="ant-menu-submenu-arrow"></i>
                </a>
                <a *ngIf="!subSubItem.submenu?.length" class="ant-menu-submenu-title p-l-50" 
                   (click)="navigate(subSubItem)">
                  <i *ngIf="subSubItem.iconType == 'nzIcon'" nz-icon [nzType]="subSubItem.icon" [theme]="subSubItem.iconTheme"></i>
                  <i *ngIf="subSubItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subSubItem.iconTheme, subSubItem.icon]"></i>
                  <span>{{ subSubItem.title | translate }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </ul>
</perfect-scrollbar>